import { cn } from '@/lib/utils'

/** Eyebrow label — matches "Featured this week" on the home marketplace. */
export function SectionLabel({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'font-mono text-[11px] font-medium uppercase tracking-[0.12em] text-text-subtle',
        className,
      )}
    >
      {children}
    </div>
  )
}

export function SectionHeading({
  label,
  title,
  className,
  titleClassName,
}: {
  label: React.ReactNode
  title: React.ReactNode
  className?: string
  titleClassName?: string
}) {
  return (
    <div className={cn('mb-3.5', className)}>
      <SectionLabel>{label}</SectionLabel>
      <h2 className={cn('mt-1 text-[22px] font-bold tracking-[-0.02em] text-text-strong', titleClassName)}>
        {title}
      </h2>
    </div>
  )
}
